import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';

export const AboutNav = () => {
  const router = useRouter();
  const currentPath = router.pathname;

  const links = [
    { key: 'about', label: 'About', href: '/about' },
    { key: 'printmaking', label: 'Printmaking', href: '/printmaking' },
  ];

  return (
    <nav className="sticky top-14 z-40 flex w-full items-center justify-center border-b border-b-divider/20 bg-white md:top-18">
      {links.map((link) => (
        <Link
          key={link.key}
          aria-current={currentPath === link.href ? 'page' : undefined}
          className={classNames(
            'p-4 transition-colors duration-300 ease-out hover:text-neutral-4',
            {
              'shadow-[0_1px_0_0_black]': currentPath === link.href,
            },
          )}
          href={link.href}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
};
